import { AmountCode, TargetSource } from 'typings/enums';
import {
    PercentageCalculationRule
} from 'nomst/Stores/Configuration/Constants/percentageCalculationRule';
import {
    AmountPayType
} from 'nomst/Stores/Configuration/Constants/amountPayType';
import { StockDisplayType } from 'typings/enums';
import { ICycleBudgetField } from 'typings/cycleBudgetField';
import { IProrationRule } from 'typings/prorationRule';
import { EligibilityRule } from 'nomst/Stores/Configuration/eligibilityRule';
import { RangeEnforcement } from 'nomst/Stores/Configuration/rangeEnforcement';
import { observable, computed, action, makeObservable } from 'mobx';

export class CycleBudgetField {
    @observable amountCycleId: number;
    @observable title: string;
    @observable amountCode: AmountCode;
    @observable mainViewPriority: Nullable<number>;
    @observable payType: AmountPayType;
    @observable eventType: string;
    @observable percentageCalculationRule: PercentageCalculationRule;
    @observable rangeEnforcement: RangeEnforcement;
    @observable contentUnderneath: IContentUnderneath;
    @observable hidePercentageIfTargetZero: boolean;
    @observable targetSource: TargetSource;
    @observable showInDetailView: boolean;
    @observable budgetCycleId: Nullable<number>;
    @observable eligibilityRule: Nullable<EligibilityRule>;
    @observable prorationRule: Nullable<IProrationRule>;
    @observable ordinal: number;
    @observable color: string;
    @observable colorPriority: number;
    @observable shouldShowOriginalBudget: boolean;
    @observable stockDisplayType: StockDisplayType;
    @observable stockValue: Nullable<number>;

    constructor(dto: ICycleBudgetField, maid: string) {
        makeObservable(this);
        this.amountCycleId = dto.amountCycleId;
        this.amountCode = dto.amountCode;
        this.title = dto.title;
        this.mainViewPriority = dto.mainViewPriority;
        this.budgetCycleId = dto.budgetCycleId;
        this.payType = dto.payType;
        this.eventType = dto.eventType;
        this.percentageCalculationRule = dto.percentageCalculationRule;
        this.rangeEnforcement = new RangeEnforcement(dto.rangeEnforcement);
        this.contentUnderneath = dto.contentUnderneath;
        this.hidePercentageIfTargetZero = dto.hidePercentageIfTargetZero;
        this.targetSource = dto.targetSource;
        this.showInDetailView = dto.showInDetailView;
        this.budgetCycleId = dto.budgetCycleId;
        this.eligibilityRule = dto.eligibilityRule ? new EligibilityRule(dto.eligibilityRule, maid) : null;
        this.prorationRule = dto.prorationRule;
        this.ordinal = dto.ordinal;
        this.color = dto.color;
        this.colorPriority = dto.colorPriority;
        this.shouldShowOriginalBudget = dto.shouldShowOriginalBudget;
        this.stockDisplayType = dto.stockDisplayType;
        this.stockValue = dto.stockValue;
    }

    @computed
    get isUnitOnly(): boolean {
        return this.amountCode === AmountCode.Stock && this.stockDisplayType === StockDisplayType.Unit;
    }

    @computed
    get hasProrationRule(): boolean {
        return this.prorationRule != null;
    }

    @action
    setStockDisplayType(value: StockDisplayType): void {
        this.stockDisplayType = value;
    }

    @action
    setBudgetCycleId(cycleBudgetId: Nullable<number>): void {
        this.budgetCycleId = cycleBudgetId;
    }

    @action
    setStockValue(value: number): void {
        this.stockValue = value;
    }

    @action
    setEligibilityRule(eligibilityRule: EligibilityRule): void {
        this.eligibilityRule = eligibilityRule;
    }

    @action
    deleteEligibilityRule(): void {
        this.eligibilityRule = null;
    }

    @action
    setProrationRule(prorationRule: Nullable<IProrationRule>): void {
        this.prorationRule = prorationRule;
    }

    @action
    deleteProrationRule(): void {
        this.prorationRule = null;
    }
}